import { capitalizeFirstLetter, getCountFromActifsAssocies } from 'utils';
import moment from 'moment';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';
import { Typography } from '@material-ui/core';
import { includesSearchWord } from 'utils';
import _ from 'lodash';
import { getPlainTextFromHtml } from 'utils';

export const columnsInspections = (codeproducts, simple) => {
    return [
        {
            name: "id",
            label: capitalizeFirstLetter("TITRE"),
            options: {
                display: false
            }
        },
        {
            name: "site_intervention",
            label: capitalizeFirstLetter("Site d'intervention"),
            options: {
                sort: true
            }
        },
        ...!simple ? [
            {
                name: "site_address",
                label: capitalizeFirstLetter("Adresse"),
                options: {
                    sort: true
                }
            },
            {
                name: "site_codepostal",
                label: capitalizeFirstLetter("Code postal"),
                options: {
                    sort: true
                }
            },
            {
                name: "site_city",
                label: capitalizeFirstLetter("Ville"),
                options: {
                    sort: true,
                }
            }] : [],
        {
            key: "domains",
            name: "domains",
            label: capitalizeFirstLetter("DOMAINE"),
            options: {
                sort: true
            }
        }]
}
export const columnsInterventions = (simple) => {
    return [
        {
            key: "interventionSEL_dateDebut",
            name: "interventionSEL.datesReelles.dateDebut",
            label: capitalizeFirstLetter("Date de début d'intervention"),
            options: {
                sort: true,
                customBodyRender: (value) => {
                    return value ? moment(value).format("DD/MM/YYYY") : ""
                }
            }
        },
        ...!simple ? [
            {
                key: "codeproduct_description",
                name: "codeproduct.description",
                label: capitalizeFirstLetter("LIBELLé PRODUIT"),
                options: {
                    sort: true
                }
            },
            {
                name: "numReports",
                label: capitalizeFirstLetter("Nombre de rapports"),
                options: {
                    sort: true,
                }
            }] : [],
        {
            name: "numObservations",
            label: capitalizeFirstLetter("Nombre d'observations"),
            options: {
                sort: true,
            }
        },
    ]
}
export const tableOptions = (button) => {
    return {
        responsive: 'standard',
        pagination: false,
        print: false,
        download: false,
        selectableRows: 'none',
        viewColumns: false,
        elevation: 0,
        filter: false,
        search: false,
        textLabels: {
            body: {
                noMatch: <div style={{ textAlign: 'center' }}>
                    <ErrorOutlineIcon />
                    <br />
                    <Typography style={{ color: "#061024", fontSize: 13 }}>
                        {"Aucun document disponible à ce jour."}
                    </Typography>
                    {button}
                </div>,
            }
        }
    }
}
export const filterTableData = (data, onFilter, filters, keyword) => {
    let result = data;
    if (onFilter && filters && !Object.values(filters).find(item => !item)) {
        result = result.filter(item => {
            const fields = Object.keys(filters)
            let inValid = false;
            for (let i = 0; i < fields.length; i++) {
                const key = fields[i]
                inValid = filters[key] && _.get(item, key, "") != filters[key]
                if (inValid) return false;
            }
            return !inValid
        })
    }
    if (keyword && keyword.length > 0) {
        result = result.filter(item => item && !!Object.values(item).find(value => value && includesSearchWord(value, keyword)))
    }
    return result
}

export const getSiteAddress = (interventionSel) => {
    const site = _.get(interventionSel, "relationIntervention", []).find(item => item.role == "SITE");
    return {
        site_intervention: _.get(site, "donneesRelation.raisonSociale", ""),
        site_address: getPlainTextFromHtml(_.get(site, "adresseRelation.adresse4", "")),
        site_codepostal: _.get(site, "adresseRelation.codePostal", ""),
        site_city: _.get(site, "adresseRelation.localiteDestination", "")
    }
}